module.exports = __webpack_public_path__ + "img/GH-kyujin-top-illustration008.53b21ee4.webp";